// extracted by mini-css-extract-plugin
export var formContainer = "_ip-0";
export var message = "_ip-1";